import { AdvisorsTable } from './AdvisorsTable';

export function AdvisorsDashboard() {
  return <AdvisorsTable />;
}
